/* @flow */
import _ from 'lodash';
import type { Action, AsyncAction, MediaSearchFullParams } from '../../types';
import { mediaSearchFullParamsProps } from '../../types/MediaSearchFullParams';

import liferay from '../../services/liferay';

const onFailure = (error: Object) => console.warn(error);

const setMediaSearch = (params: MediaSearchFullParams): Action => {
  return {
    type: 'SET_MEDIA_SEARCH',
    payload: _.pick(params, mediaSearchFullParamsProps),
  };
};

const performMediaSearch = (params: MediaSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'PERFORM_MEDIA_SEARCH_REQUEST',
    payload: params,
    promise: params.text ? liferay.medias.find(params) : Promise.resolve({ categoryIds: [] }),
    meta: { onFailure },
  };
};

const fetchMediaSearchPage = (params: MediaSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_MEDIA_SEARCH_PAGE_REQUEST',
    payload: params,
    promise: liferay.medias.find(params),
    meta: { onFailure },
  };
};

const mediaSearchSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'MEDIA_SEARCH_SCROLL_PAGE',
    payload: pageScroll,
  };
};

const mediaSearchToggleExpandCategory = (categoryId: number): Action => {
  return {
    type: 'MEDIA_SEARCH_TOGGLE_EXPAND_CATEGORY',
    payload: categoryId,
  };
};

const mediaSearchSetCategorySlide = (categoryId: number, slideIndex: number): Action => {
  return {
    type: 'MEDIA_SEARCH_SET_CATEGORY_SLIDE',
    payload: {
      categoryId,
      slideIndex,
    },
  };
};

export default {
  setMediaSearch,
  performMediaSearch,
  fetchMediaSearchPage,
  mediaSearchToggleExpandCategory,
  mediaSearchSetPageScroll,
  mediaSearchSetCategorySlide,
};
